import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectSyncState } from '../../reducer/app';
import { useAppSelector } from '../../hooks';
import { SyncState } from 'matrix-js-sdk/lib/sync';
// @ts-ignore – i18n.js is a plain JS file without type declarations
import i18n from '../../i18n';
const isSyncFailed = (state) => {
    return !(state === SyncState.Prepared ||
        state === SyncState.Syncing ||
        state === SyncState.Catchup);
};
const AlertSyncState = () => {
    const [failedId, setFailedId] = React.useState(null);
    const [lastState, setLastState] = React.useState(null);
    const syncState = useAppSelector(selectSyncState);
    React.useEffect(() => {
        if (failedId) {
            toast.dismiss(failedId);
        }
        if (syncState.state === lastState)
            return;
        let newFailedId = null;
        if (syncState.state === SyncState.Error) {
            newFailedId = toast.warn(i18n.t('error_network'));
        }
        setFailedId(newFailedId);
        if (!isSyncFailed(syncState.state) &&
            syncState.lastState !== null && syncState.lastState !== SyncState.Reconnecting &&
            isSyncFailed(syncState.lastState)) {
            toast.success(i18n.t('network_recovered'));
        }
        setLastState(syncState.state);
        return;
    }, [syncState]);
    return React.createElement(ToastContainer, null);
};
export default AlertSyncState;
